import type { AssistantFailureMessage } from '@/entities/discovery';
import { InfoIcon } from 'lucide-react';
import { AssistantMessageRow } from './primitives';

export const AssistantMessageFailure = ({ message }: { message: AssistantFailureMessage }) => {
  return (
    <AssistantMessageRow>
      <div className="mt-1 flex flex-col items-start gap-3">
        <span className="text-primary text-sm">{message.content.message}</span>
        <div className="flex gap-2">
          <InfoIcon className="text-muted-foreground size-4" />
          <p className="text-muted-foreground text-sm">{message.content.failure_reason}</p>
        </div>
      </div>
    </AssistantMessageRow>
  );
};
